import JwtToken from "../components/lib/tokens/JwtToken";
import { WorkflowStep } from "./WorkflowStepType";
import { AppSecurityKey } from "./AppSecurityKey";


export default class RoleManager
{

    static hasRoleRights(appSecurityKey, token)
    {
        if (!token) return false;
        var result = JwtToken.hasAnyRoles(token, appSecurityKey.roles);
        return result;
    };


    static toLandingPage(token)
    {
        if (this.hasRoleRights(AppSecurityKey.VIEW_OBSHOME, token)) return "/home/home-page";
        if (this.hasRoleRights(AppSecurityKey.VIEW_DASHBOARD, token)) return "/home/dashboard-page";
        if (this.hasRoleRights(AppSecurityKey.EDIT_DATALISTS, token)) return "/home/datamanagement-page";
        if (this.hasRoleRights(AppSecurityKey.EDIT_USERS, token)) return "/home/usermanagement-page";
        return "";
    }


    static toWorkflowStep(workflowSchema, workflowStepString)
    {
        //var result = Object.keys(workflowSchema).find((key) => workflowSchema[key].id === workflowStepString);
        var result = workflowSchema[workflowStepString.toUpperCase()];
        if (!result)
        {
            // fallback to NONE if no match found
            result = workflowSchema["NONE"];
        }
        return result;
    }

    static toDefaultWorkflowStep(workflowSchema)
    {
        var result = Object.keys(workflowSchema).find((key) => workflowSchema[key].isDefault === true);
        return result;
    }



    static hasWorkflowStepTransitionAccess(workflowSchema, workflowStepId, token)
    {
        if ((!token) || (!workflowStepId)) return false;
        var workflow = workflowSchema[workflowStepId.toUpperCase()];
        var transitionRoles = workflow.transitions.map((t) => t.roles).flat();
        var uniqueRoles = [...new Set(transitionRoles)];
        var result = JwtToken.hasAnyRoles(token, uniqueRoles);
        return result;
    }

    static toWorkflowStepList(workflowSchema)
    {
        var result = Object.keys(workflowSchema).map((key) => workflowSchema[key].id);
        return result;
    }



    static toAvailableWorkflowStepList(workflowSchema, workflowStep, token)
    {
        if ((!token) || (!workflowStep)) return [];
        var workflow = workflowSchema[workflowStep.toUpperCase()];
        var filtered = workflow.transitions.filter((t) => (JwtToken.hasAnyRoles(token, t.roles)));
        var result = filtered.map((f) => workflowSchema[f.status.toUpperCase()]);
        return result;
    }





} 